/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AiQueryInteractionDto } from '../models/ai-query-interaction-dto';
import { AiQuerySessionDto } from '../models/ai-query-session-dto';
import { aiSessionsPost$Json } from '../fn/ai-query/ai-sessions-post-json';
import { AiSessionsPost$Json$Params } from '../fn/ai-query/ai-sessions-post-json';
import { aiSessionsPost$Plain } from '../fn/ai-query/ai-sessions-post-plain';
import { AiSessionsPost$Plain$Params } from '../fn/ai-query/ai-sessions-post-plain';
import { aiSessionsSessionIdAskPost$Json } from '../fn/ai-query/ai-sessions-session-id-ask-post-json';
import { AiSessionsSessionIdAskPost$Json$Params } from '../fn/ai-query/ai-sessions-session-id-ask-post-json';
import { aiSessionsSessionIdAskPost$Plain } from '../fn/ai-query/ai-sessions-session-id-ask-post-plain';
import { AiSessionsSessionIdAskPost$Plain$Params } from '../fn/ai-query/ai-sessions-session-id-ask-post-plain';
import { aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json } from '../fn/ai-query/ai-sessions-session-id-interactions-interaction-id-accept-post-json';
import { AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Params } from '../fn/ai-query/ai-sessions-session-id-interactions-interaction-id-accept-post-json';
import { aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain } from '../fn/ai-query/ai-sessions-session-id-interactions-interaction-id-accept-post-plain';
import { AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Params } from '../fn/ai-query/ai-sessions-session-id-interactions-interaction-id-accept-post-plain';
import { QueryDto } from '../models/query-dto';

@Injectable({ providedIn: 'root' })
export class AiQueryApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `aiSessionsPost()` */
  static readonly AiSessionsPostPath = '/ai/sessions';

  /**
   * Start AI query session.
   *
   * Starts a new AI assistant session for current user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiSessionsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsPost$Plain$Response(params?: AiSessionsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AiQuerySessionDto>> {
    const obs = aiSessionsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Start AI query session.
   *
   * Starts a new AI assistant session for current user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiSessionsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsPost$Plain(params?: AiSessionsPost$Plain$Params, context?: HttpContext): Observable<AiQuerySessionDto> {
    const resp = this.aiSessionsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AiQuerySessionDto>): AiQuerySessionDto => r.body)
    );
  }

  /**
   * Start AI query session.
   *
   * Starts a new AI assistant session for current user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiSessionsPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsPost$Json$Response(params?: AiSessionsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AiQuerySessionDto>> {
    const obs = aiSessionsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Start AI query session.
   *
   * Starts a new AI assistant session for current user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiSessionsPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsPost$Json(params?: AiSessionsPost$Json$Params, context?: HttpContext): Observable<AiQuerySessionDto> {
    const resp = this.aiSessionsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AiQuerySessionDto>): AiQuerySessionDto => r.body)
    );
  }

  /** Path part for operation `aiSessionsSessionIdAskPost()` */
  static readonly AiSessionsSessionIdAskPostPath = '/ai/sessions/{sessionId}/ask';

  /**
   * Ask AI assistant.
   *
   * Sends a natural language question and returns suggestions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiSessionsSessionIdAskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  aiSessionsSessionIdAskPost$Plain$Response(params: AiSessionsSessionIdAskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AiQueryInteractionDto>> {
    const obs = aiSessionsSessionIdAskPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ask AI assistant.
   *
   * Sends a natural language question and returns suggestions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiSessionsSessionIdAskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  aiSessionsSessionIdAskPost$Plain(params: AiSessionsSessionIdAskPost$Plain$Params, context?: HttpContext): Observable<AiQueryInteractionDto> {
    const resp = this.aiSessionsSessionIdAskPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AiQueryInteractionDto>): AiQueryInteractionDto => r.body)
    );
  }

  /**
   * Ask AI assistant.
   *
   * Sends a natural language question and returns suggestions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiSessionsSessionIdAskPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  aiSessionsSessionIdAskPost$Json$Response(params: AiSessionsSessionIdAskPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AiQueryInteractionDto>> {
    const obs = aiSessionsSessionIdAskPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ask AI assistant.
   *
   * Sends a natural language question and returns suggestions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiSessionsSessionIdAskPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  aiSessionsSessionIdAskPost$Json(params: AiSessionsSessionIdAskPost$Json$Params, context?: HttpContext): Observable<AiQueryInteractionDto> {
    const resp = this.aiSessionsSessionIdAskPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AiQueryInteractionDto>): AiQueryInteractionDto => r.body)
    );
  }

  /** Path part for operation `aiSessionsSessionIdInteractionsInteractionIdAcceptPost()` */
  static readonly AiSessionsSessionIdInteractionsInteractionIdAcceptPostPath = '/ai/sessions/{sessionId}/interactions/{interactionId}/accept';

  /**
   * Accept AI suggestion.
   *
   * Creates a saved query from an AI suggestion.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Response(params: AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Accept AI suggestion.
   *
   * Creates a saved query from an AI suggestion.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain(params: AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /**
   * Accept AI suggestion.
   *
   * Creates a saved query from an AI suggestion.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Response(params: AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Accept AI suggestion.
   *
   * Creates a saved query from an AI suggestion.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json(params: AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

}
